import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { Redirect } from "react-router-dom";
import { LogoutUser,UpdateLogonTransaction } from '../../action/authenticateUser';


class PropertyManagerLogout extends Component {

  constructor(props){
    super(props);
    this.state = {
      Logout : true,
    };
}

  componentWillMount() {
    if (this.props.authentication_response != null && parseInt(this.props.authentication_response.userTransaction) > 0) {
      var logondetails = {
        "LogOnTransaction": false,
        "LogOffType": false,
        "LogOnTransactionId": parseInt(this.props.authentication_response.userTransaction)
      }
      this.props.UpdateLogonTransaction(logondetails);
    }
    this.props.LogoutUser();
  }

componentWillReceiveProps(nextProps) {
  // if (this.props != nextProps) {
  //   this.setState({ Logout: nextProps.authentication_response.loggedIn });
  // }
}


    render() {
      localStorage.setItem('jwt', null);
      localStorage.setItem('refreshjwt', null);
      
      

      return (
               <Redirect to="/" />
            );
      // if(this.state.Logout === false){
      //   console.log("testing")
      //   return <Redirect to={"/facilitylogin"} />
      // }
      //   return (
      //        <Redirect to="/facilitylogin" />
      //     );
    }
}


const mapStateToProps = state => {
  return {
    authentication_response: state.authService
  };
};

const mapDispatchToProps = dispatch => {
  return {
      LogoutUser: () => dispatch(LogoutUser()),
      UpdateLogonTransaction: (logondetails) => dispatch(UpdateLogonTransaction(logondetails))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PropertyManagerLogout);



